/** Shared chrome for single-line staff fields. 42px matches the original InputText box (label excluded). */
export const staffFieldShell =
  "flex h-[42px] min-h-[42px] w-full items-center rounded-md px-3 text-left text-sm transition-colors";

/** Outer field wrapper so grid/flex rows stretch and keep labels aligned at the top. */
export const staffFieldRoot = "flex h-full flex-col gap-1";

/**
 * Slot under the label for short controls (radio, toggle, checkbox group).
 * With stretch it vertically centers; alone it keeps natural height.
 */
export const staffFieldControlSlot = "my-auto";
